import * as Sentry from '@sentry/react';

const reportWebVitals = onPerfEntry => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS((metric) => {
        onPerfEntry(metric);
        Sentry.metrics.distribution('web_vitals.cls', metric.value);
      });
      getFID((metric) => {
        onPerfEntry(metric);
        Sentry.metrics.distribution('web_vitals.fid', metric.value);
      });
      getFCP((metric) => {
        onPerfEntry(metric);
        Sentry.metrics.distribution('web_vitals.fcp', metric.value);
      });
      getLCP((metric) => {
        onPerfEntry(metric);
        Sentry.metrics.distribution('web_vitals.lcp', metric.value);
      });
      getTTFB((metric) => {
        onPerfEntry(metric);
        Sentry.metrics.distribution('web_vitals.ttfb', metric.value);
      });
    });
  }
};

export default reportWebVitals;
